import React from 'react';
import cn from 'classnames';

import { ReactComponent as LogoIco } from 'assets/logo.svg';
import styles from './_logo.module.scss';

interface Props {
  className?: string;
}

const Logo: React.FC<Props> = (props: Props) => {
  const { className } = props;
  const finalClassName = [styles.root];
  if (className) finalClassName.push(className);

  return (
    <div className={cn(finalClassName)}>
      <div className={styles.ico}>
        <LogoIco />
      </div>
      <span className={styles.title}>Pulse</span>
    </div>
  );
};

export { Logo };
